import React from 'react';
import { Building2, Briefcase, Landmark, Coins, MapPin, ScrollText, Trophy, Dice5 } from 'lucide-react';
import { MonopolyCard } from '../components/ui/MonopolyCard';
import { ChanceCard } from '../components/ui/ChanceCard';
import { GameButton } from '../components/ui/GameButton';
export function HomePage() {
  return <div className="min-h-screen bg-[#CDE6D0] font-sans text-black overflow-x-hidden" data-id="element-19">
      <style data-id="element-20">
        {`
          @import url('https://fonts.googleapis.com/css2?family=Aleo:ital,wght@0,400;0,700;1,400&family=Koulen&display=swap');
          .bg-board-pattern {
            background-image: radial-gradient(#1a1a1a 1px, transparent 1px);
            background-size: 20px 20px;
            opacity: 0.05;
          }
        `}
      </style>

      {/* Background Pattern */}
      <div className="fixed inset-0 bg-board-pattern pointer-events-none" data-id="element-21" />

      {/* Navigation / Header */}
      <header className="relative z-10 bg-white border-b-4 border-black py-6 px-4 shadow-xl" data-id="element-22">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-23">
          <div className="bg-[#E3000F] text-white px-8 py-3 border-2 border-black shadow-[4px_4px_0px_0px_rgba(0,0,0,1)] transform -rotate-2" data-id="element-24">
            <h1 className="font-['Koulen'] text-4xl md:text-5xl tracking-widest uppercase" data-id="element-25">
              RATIONALPRO
            </h1>
          </div>

          <div className="flex gap-4 font-['Koulen'] text-xl tracking-wide" data-id="element-26">
            <a href="#kolekcja" className="hover:text-[#E3000F] transition-colors uppercase" data-id="element-27">
              Kolekcja
            </a>
            <a href="#o-nas" className="hover:text-[#E3000F] transition-colors uppercase" data-id="element-28">
              O Firmie
            </a>
            <a href="#kontakt" className="hover:text-[#E3000F] transition-colors uppercase" data-id="element-29">
              Lokalizacja
            </a>
          </div>
        </div>
      </header>

      <main className="relative z-10 max-w-7xl mx-auto px-4 py-12 space-y-24" data-id="element-30">
        {/* Hero Section */}
        <section className="text-center space-y-8 py-12" data-id="element-31">
          <div className="inline-block bg-white border-2 border-black p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)] max-w-3xl mx-auto" data-id="element-32">
            <h2 className="font-['Koulen'] text-5xl md:text-7xl mb-4 leading-none" data-id="element-33">
              ZAINWESTUJ W <span className="text-[#1FB25A]" data-id="element-34">WIEDZĘ</span>
            </h2>
            <p className="font-['Aleo'] text-xl md:text-2xl text-gray-700 mb-8 italic" data-id="element-35">
              "Najlepsza inwestycja to ta, którą rozumiesz."
            </p>
            <div className="flex justify-center gap-4 flex-wrap" data-id="element-36">
              <GameButton icon={Dice5} data-id="element-37">Rzuć Kostką</GameButton>
              <GameButton variant="secondary" icon={Briefcase} data-id="element-38">
                Przeglądaj Ofertę
              </GameButton>
            </div>
          </div>
        </section>

        {/* Collection Grid */}
        <section id="kolekcja" className="relative" data-id="element-39">
          <div className="absolute -left-4 top-0 bg-black text-white px-4 py-2 font-['Koulen'] text-2xl transform -rotate-90 origin-top-left border-2 border-white" data-id="element-40">
            NIERUCHOMOŚCI
          </div>

          <h2 className="font-['Koulen'] text-4xl text-center mb-12 uppercase tracking-widest border-b-4 border-black inline-block mx-auto px-12 pb-2" data-id="element-41">
            Ekskluzywne Gry Finansowe
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 justify-items-center" data-id="element-42">
            {/* Brown Properties */}
            <MonopolyCard color="#955436" title="Spekulacja Gruntowa" price="120" features={['Strategia: Niska', 'Ryzyko: Wysokie', 'Graczy: 2-4']} icon={<MapPin className="text-white" data-id="element-44" />} data-id="element-43" />
            <MonopolyCard color="#955436" title="Czynszowa Kamienica" price="140" features={['Strategia: Średnia', 'Dochód: Pasywny', 'Graczy: 2-5']} icon={<Building2 className="text-white" data-id="element-46" />} data-id="element-45" />

            {/* Light Blue Properties */}
            <MonopolyCard color="#AAE0FA" title="Weksel i Obligacja" price="200" features={['Ekonomia: Klasyczna', 'Poziom: Ekspert', 'Czas: 120 min']} icon={<ScrollText className="text-black opacity-60" data-id="element-48" />} data-id="element-47" />
            <MonopolyCard color="#AAE0FA" title="Imperium Rentierskie" price="220" features={['Skala: Makro', 'Zarządzanie: Portfel', 'Graczy: 3-6']} icon={<Landmark className="text-black opacity-60" data-id="element-50" />} data-id="element-49" />

            {/* Pink Properties */}
            <MonopolyCard color="#D93A96" title="Kryptowalutowa Gorączka" price="280" features={['Zmienność: Ekstremalna', 'Technologia: Blockchain', 'Nowość 2026']} icon={<Coins className="text-white" data-id="element-52" />} data-id="element-51" />
            <MonopolyCard color="#D93A96" title="Start-up Jednorożec" price="300" features={['Inwestycje: VC', 'Exit: IPO', 'Ryzyko: Totalne']} icon={<Trophy className="text-white" data-id="element-54" />} data-id="element-53" />

            {/* Orange Properties */}
            <MonopolyCard color="#F7941D" title="Arbitraż Walutowy" price="350" features={['Rynek: Forex', 'Dźwignia: 1:100', 'Dla Profesjonalistów']} icon={<Briefcase className="text-white" data-id="element-56" />} data-id="element-55" />
            <MonopolyCard color="#F7941D" title="Hedge Fund Manager" price="400" features={['Strategia: Short', 'Instrumenty: Derywaty', 'Prestiż: Max']} icon={<Landmark className="text-white" data-id="element-58" />} data-id="element-57" />
          </div>
        </section>

        {/* Chance & Community Chest Section */}
        <section id="o-nas" className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center max-w-4xl mx-auto" data-id="element-59">
          <div className="flex justify-center" data-id="element-60">
            <ChanceCard type="chance" title="Szansa" description="Odwiedź nasz sklep stacjonarny i otrzymaj 10% rabatu na pierwszą grę edukacyjną." data-id="element-61" />
          </div>
          <div className="flex justify-center" data-id="element-62">
            <ChanceCard type="chest" title="Kasa Społeczna" description="RATIONALPRO to więcej niż sklep. To centrum edukacji finansowej dla przyszłych milionerów." data-id="element-63" />
          </div>
        </section>

        {/* Location / Contact Footer Strip */}
        <section id="kontakt" className="bg-white border-2 border-black p-8 shadow-[8px_8px_0px_0px_rgba(0,0,0,1)]" data-id="element-64">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center md:text-left" data-id="element-65">
            <div className="space-y-4" data-id="element-66">
              <h3 className="font-['Koulen'] text-2xl uppercase border-b-2 border-black inline-block" data-id="element-67">
                Adres
              </h3>
              <p className="font-['Aleo'] text-lg" data-id="element-68">
                ul. CHMIELNA 73B/14
                <br data-id="element-69" />
                00-801 WARSZAWA
                <br data-id="element-70" />
                POLSKA
              </p>
            </div>

            <div className="space-y-4" data-id="element-71">
              <h3 className="font-['Koulen'] text-2xl uppercase border-b-2 border-black inline-block" data-id="element-72">
                Firma
              </h3>
              <p className="font-['Aleo'] text-lg" data-id="element-73">
                RATIONALPRO
                <br data-id="element-74" />
                KRS: 0000751433
              </p>
            </div>

            <div className="space-y-4 flex flex-col items-center md:items-start" data-id="element-75">
              <h3 className="font-['Koulen'] text-2xl uppercase border-b-2 border-black inline-block" data-id="element-76">
                Godziny
              </h3>
              <p className="font-['Aleo'] text-lg" data-id="element-77">
                Pn - Pt: 10:00 - 18:00
                <br data-id="element-78" />
                Sb: 10:00 - 14:00
              </p>
              <GameButton className="mt-2 w-full md:w-auto" data-id="element-79">
                Znajdź na Mapie
              </GameButton>
            </div>
          </div>
        </section>
      </main>

      {/* Copyright Footer */}
      <footer className="bg-black text-white py-6 text-center font-['Aleo']" data-id="element-80">
        <p className="opacity-80" data-id="element-81">© 2026 RATIONALPRO. All rights reserved.</p>
      </footer>
    </div>;
}